/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Container, Form } from "react-bootstrap";
import { Button, Input } from "../../../components";
import { useLocation } from "react-router";
import { format } from "date-fns";
import { LableFromEnums } from "../../../utilities";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import {
  GenerateAssociateInvoice,
  GetAssociateBookingDetails,
} from "../../../utilities/api/associateBooking";
import { ConfirmCancelModal } from "../CourtsBooking/ConfirmCancelModal";
import { toast } from "react-toastify";

const AssociateGenerateInvoice = () => {
  const [allData, setAllData] = useState(useLocation().state);
  const [data, setData] = useState(useLocation().state.bookingInvoices);
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const [discount, setDiscount] = useState<any>({});
  const [disableTds, setDisableTds] = useState<any>({});
  const [tdsPercent, setTdsPercent] = useState<any>({});
  const [isCompleted, setIsCompleted] = useState<any>({});
  const [show, setShow] = useState(false);
  const [collectCashId, setCollectCashId] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    let checkDateObj = {};
    data?.forEach((item: any) => {
      let year = new Date(item.yearMonth).getFullYear();
      let month = new Date(item.yearMonth).getMonth() + 2;
      const checkDate = new Date(`${year}-${month}`);
      checkDateObj = { ...checkDateObj, [item.id]: checkDate <= new Date() };
    });

    setIsCompleted(checkDateObj);
  }, []);

  const handleGenerateInvoice = async (id: any) => {
    const genrateInvoice = await GenerateAssociateInvoice(allData.id, id, {
      discount: Number(discount[id]) || 0,
      tdsPercent: Number(tdsPercent[id]) || 0,
    });
    if (genrateInvoice.status === 200) {
      GetData();
    } else {
      toast.error(genrateInvoice.response.data.message);
    }
  };

  const GetData = async () => {
    const result = await GetAssociateBookingDetails(allData.id);
    if (result?.statusCode === 200) {
      setAllData(result.data);
      setData(result.data.bookingInvoices);
    } else {
      toast.error(result.response.data.message);
    }
  };

  const handleDownloadInvoice = async (hash: string, id: any) => {
    window.open("/printing/?type=invoice&prefix=ACB&id=" + id + "&hash=" + hash, "_blank");

  };

  const payableAmount = (item: any) => {
    return (
      Math.round(
        Number(item?.subTotal) -
        Number(discount[item?.id] || 0) +
        (Number(item?.subTotal - discount[item?.id] || 0) *
          Number(
            allData.bookingTaxes?.length > 1
              ? allData.bookingTaxes?.reduce(
                (acc: any, cur: any) =>
                  Number(acc.percentage) + Number(cur.percentage)
              )
              : allData.bookingTaxes[0].percentage
          )) /
        100 -
        ((Number(item?.subTotal) - Number(discount[item?.id] || 0)) *
          tdsPercent[item.id]) /
        100
      ) || item.totalAmount?.toFixed(2)
    );
  };

  return (
    <>
      <Container className="g-0" fluid>
        <Card>
          <Card.Body>
            <Card.Title className="text-start mb-0">
              Generate Invoice
            </Card.Title>
            <hr />
            <div className="table-responsive">
            <table className="react-table text-start table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Month </th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Amount</th>
                  <th>Discount</th>
                  <th>Collect Amount</th>
                  <th>TDS</th>
                  <th>Enter TDS %</th>
                  <th>TDS Amount</th>
                  <th>Payable Amount</th>
                  <th>Payment Status</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item: any) => {
                  return (
                    <tr key={item?.id}>
                      <td>{format(new Date(item?.yearMonth), "MMM yy")}</td>
                      <td>{item?.startDate}</td>
                      <td>{item?.endDate}</td>
                      <td>{item?.subTotal?.toFixed(2)}</td>
                      <td>
                        {isCompleted[item.id] && item.discount === null ? (
                          <Input
                            type="number"
                            onChange={(e: any) => {
                              if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                                setDiscount({
                                  ...discount,
                                  [item?.id]: e.target.value,
                                });
                              }
                            }}
                            value={discount[item?.id]}
                            className="form-control form-control-sm w-75"
                            name="disc"
                            id="disc"
                            onKeyDown={(e: any) =>
                              ["e", ".", "-", "+"].includes(e.key) &&
                              e.preventDefault()
                            }
                          />
                        ) : (
                          item.discount || '-'
                        )}
                      </td>
                      <td>
                        {item.discount === null
                          ? (
                            Number(item?.subTotal) -
                            Number(discount[item?.id] || 0)
                          )?.toFixed(2)
                          : (
                            Number(item?.subTotal) -
                            Number(item.discount || 0)
                          )?.toFixed(2)}
                      </td>
                      <td>
                        {isCompleted[item.id] && item.tdsPercent === null ? (
                          <Form.Check
                            label=""
                            name="TDS"
                            type="checkbox"
                            id="TDS"
                            value={
                              [null, undefined, "false"].includes(
                                disableTds[item.id]
                              )
                                ? "true"
                                : "false"
                            }
                            checked={
                              disableTds[item.id] === "true" ? true : false
                            }
                            onChange={(e: any) =>
                              setDisableTds({
                                ...disableTds,
                                [item.id]: e.target.value,
                              })
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {item.tdsPercent !== null ? (
                          item.tdsPercent
                        ) : disableTds[item.id] === "true" ? (
                          <Input
                            onChange={(e: any) => {
                              if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                                setTdsPercent({
                                  ...tdsPercent,
                                  [item?.id]: e.target.value,
                                });
                              }
                            }}
                            type="number"
                            value={tdsPercent[item?.id]}
                            className="form-control form-control-sm w-75"
                            name="tdspercent"
                            id="tdspercent"
                            onKeyDown={(e: any) =>
                              ["e", ".", "-", "+"].includes(e.key) &&
                              e.preventDefault()
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {disableTds[item.id] === "true" &&
                          item.tdsAmount === null
                          ? (
                            ((Number(item?.subTotal) -
                              Number(discount[item?.id] || 0)) *
                              tdsPercent[item.id]) /
                            100
                          )?.toFixed(2) || "-"
                          : item.tdsAmount !== null
                            ? item.tdsAmount?.toFixed(2)
                            : "-"}
                      </td>
                      <td>
                        {item.discount === null && item.tdsAmount === null
                          ? payableAmount(item)
                          : item.totalAmount?.toFixed(2)}
                      </td>
                      <td>{LableFromEnums(item.paymentStatus, Enums)}</td>
                      <td>
                        {item.discount === null ? (
                          <Button
                            disabled={!isCompleted[item.id]}
                            onClick={() => handleGenerateInvoice(item.id)}
                            type="button"
                            bname="Generate Invoice"
                            name="invoice"
                            id="invoice"
                            className="btn btn-primary btn-sm  text-nowrap"
                          ></Button>
                        ) : (
                          <Button
                            disabled={["paid", "refunded"].includes(
                              item.paymentStatus
                            )}
                            onClick={() => {
                              handleShow();
                              setCollectCashId(item.id);
                            }}
                            type="button"
                            bname={
                              item.paymentStatus === "pending"
                                ? "Collect Cash"
                                : item.paymentStatus === "refunded"
                                  ? "Cash Refunded"
                                  : "Cash Collected"
                            }
                            name="collectCash"
                            id="collectCash"
                            className="btn btn-primary btn-sm  text-nowrap"
                          ></Button>
                        )}
                      </td>
                      <td>
                        <Button
                          onClick={() => handleDownloadInvoice(item.hash, item.id)}
                          disabled={item.discount === null}
                          type="button"
                          bname="Download Invoice"
                          name="downloadinvoice"
                          id="downloadinvoice"
                          className="btn btn-primary btn-sm text-nowrap"
                        ></Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
          </Card.Body>
        </Card>
        <ConfirmCancelModal
          show={show}
          handleClose={handleClose}
          name={"Associate Collect Cash"}
          id={{ bookingId: allData.id, invoiceId: collectCashId }}
          GetData={GetData}
        />
      </Container>
    </>
  );
};
export { AssociateGenerateInvoice };
